export default "__VITE_ASSET__BdWYn3N4__"